module.exports = __webpack_public_path__ + "img/share-btn-right.9b9558e0.png";